import { render, staticRenderFns } from "./AllMoneyDetail.vue?vue&type=template&id=54952500&scoped=true&"
import script from "./AllMoneyDetail.vue?vue&type=script&lang=js&"
export * from "./AllMoneyDetail.vue?vue&type=script&lang=js&"
import style0 from "./AllMoneyDetail.vue?vue&type=style&index=0&id=54952500&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54952500",
  null
  
)

export default component.exports